var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourescent101({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 7.75,
    className: "st2",
    width: 4.84,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.62,
    y: 7.75,
    className: "st2",
    width: 4.84,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 7.36,
    className: "st2",
    width: 0.5,
    height: 1.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 7.36,
    className: "st2",
    width: 0.5,
    height: 1.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.92,9.95C6.85,9.95,5.98,9.07,5.98,8s0.87-1.95,1.95-1.95S9.87,6.93,9.87,8S9,9.95,7.92,9.95z M7.92,6.55 C7.13,6.55,6.48,7.2,6.48,8s0.65,1.45,1.45,1.45S9.37,8.8,9.37,8S8.72,6.55,7.92,6.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.52,8.73 7.2,7.45 7.37,7.27 8.69,8.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.37,8.73 7.2,8.55 8.52,7.27 8.69,7.45  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourescent101);
export default __webpack_public_path__ + "static/media/Flourescent1-01.0b8f383b914e60602fa6dd20702dea35.svg";
export { ForwardRef as ReactComponent };